import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Map } from 'lucide-react';

const SelectAddress = ({onChange, options, host_url}) => {
  const [address_text, setAddressText] = useState('');
  const [show_map, setShowMap] = useState(options?.show_map || false);
  const selected_address = useRef({});
  const iframe_ref = useRef(null);

  const gmap_url = useMemo(() => {
    const params = new URLSearchParams();
    const lat_long = options?.lat_long;
    if (lat_long?.lat !== undefined) params.set('lat', lat_long.lat);
    if (lat_long?.lng !== undefined) params.set('lng', lat_long.lng);
    if (options?.address) params.set('address', options.address);
    const query = params.toString();
    return `${host_url || ""}/user/location?action=loadmap${query ? `&${query}` : ''}`;
  }, [options?.address, options?.lat_long?.lat, options?.lat_long?.lng]);

  useEffect(() => {
    const onSelection = (event) => {
      if (
        event.source !== iframe_ref.current?.contentWindow ||
        event.data?.type !== 'gmap:location:change'
      ) return;

      const {lat, lng, address} = event.data;
      if (typeof lat !== 'number' || typeof lng !== 'number') return;

      // Preserve the Google Place-compatible shape expected by existing callers.
      const location = {lat: () => lat, lng: () => lng};
      selected_address.current = {
        ...selected_address.current,
        formatted_address: address || '',
        geometry: {location}
      };
      setAddressText(address || '');
      onChange(selected_address.current);
    };

    window.addEventListener('message', onSelection);
    return () => window.removeEventListener('message', onSelection);
  }, [onChange]);

  const onManualAddressChange = (event) => {
    const formatted_address = event.target.value;
    setAddressText(formatted_address);
    // Manual text entry is not a map pick — drop any prior geometry so callers
    // don't keep stale/random lat_long and the API can geocode the text instead.
    selected_address.current = {formatted_address};
    onChange(selected_address.current);
  };

  return (
    <>
      <div className={`w3-relative w3-flex w3-border w3-round ${options?.hide_address_input ? 'w3-hide' : ''}`}>
        <textarea
          value={address_text}
          placeholder="Enter Address here"
          className="input-primary w3-no-outline w3-flex-grow-s1 w3-padding-8"
          onChange={onManualAddressChange}
        />
        <div className="w3-flex-col w3-center w3-flex-hcenter w3-border-left">
          <Map
            onClick={() => setShowMap(!show_map)}
            className="w3-text-green tw-m-2"
            size={24}
          />
        </div>
      </div>
      <div style={{height: '50vh'}} className={`${show_map ? 'w3-row tw-relative tw-mb-20' : 'w3-display-none'} w3-flex-grow-s1`}>
        {show_map ? (
          <iframe
            ref={iframe_ref}
            title="Select address"
            src={gmap_url}
            className="w3-expand w3-occupy"
            style={{border: 0}}
            allow="geolocation"
          />
        ) : null}
      </div>
    </>
  );
};

export default SelectAddress
